<template>
  <div id="MHeaderNav" class="mobilePage">
    <div class="headerPanel">
      <div class="headerContentPanel flex-center-between">
        <div class="headerContentLeft flex" @click="showPopup">
          <img src="@/images/mCom/nav_down_icon.png" alt />
        </div>
        <div class="headeContentRight flex">
          <img src="@/images/mCom/logo.png" alt />
        </div>
      </div>
    </div>
    <!-- 默认菜单 -->
    <van-popup
      :closeable="true"
      v-model="show"
      lock-scroll
      position="left"
      :style="{ width: '4.44rem', height: '100%' }"
    >
      <div class="navItemPanel" v-if="showNav">
        <div
          class="navItem"
          v-for="(item, index) in navItem"
          :key="index"
          @click="changeNav(item.path)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="navItemPanel dropItemPanel" v-if="showDrop">
        <div class="left-gray-arrow-panel flex-center-start" @click="returnNav">
          <img
            class="left-gray-arrow"
            src="@/images/com/left_gray_arrow.png"
            alt=""
          />
        </div>
        <div
          class="navItem"
          v-for="(item, index) in dropParams"
          :key="index"
          @click="changeDrop(item.path)"
        >
          <div class="dropItemCont flex-center-between">
            <span>{{ item.name }}</span>
            <img
              class="right-gray-double-arrow"
              src="@/images/com/right_gray_double_arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      showNav: false,
      showDrop: false,
      navItem: [
        { name: "首页", path: "mHome" },
        { name: "主会场", path: "mTheMainVenue" },
        { name: "分会场", path: "mBranchVenue" },
        { name: "金陀螺奖", path: "mGoldenTopAward" },
        { name: "创意互动展区", path: "mCloudExhibitionArea" },
        { name: "大会动态", path: "mConferenceNews" },
        { name: "往届回顾", path: "1" },
      ],
      dropParams: [
        {
          name: "FBEC2020",
          path: "https://www.fbec.info/jintuoluo2020/index.html#/",
        },
        {
          name: "FBEC2019",
          path: "https://www.fbec.info/jintuoluo2019/index.html",
        },
        {
          name: "FBEC2018",
          path: "http://www.youxituoluo.com/jintuoluo2018",
        },
        {
          name: "第二届金陀螺奖",
          path: "http://www.youxituoluo.com/jintuoluo2017",
        },
        {
          name: "首届金陀螺奖",
          path: "http://www.youxituoluo.com/jintuoluo2016",
        },
      ],
    };
  },

  methods: {
    showPopup() {
      this.show = true;
      this.showNav = true;
      this.showDrop = false;
    },
    // 菜单跳转
    changeNav(path) {
      if (path != 1) {
        this.$router.push({ name: path });
        this.show = false;
      } else {
        this.showNav = false;
        this.showDrop = true;
      }
    },
    // 往届回顾跳转
    changeDrop(path) {
      window.open(path, "_blank");
      this.show = false;
    },
    // 返回
    returnNav() {
      this.showDrop = false;
      this.showNav = true;
    },
  },
};
</script>
<style lang="scss" scoped>
#MHeaderNav {
  .headerPanel {
    width: 100%;
    height: 1.02rem;
    background: rgba(1, 3, 18, 1);
  }

  .headerContentPanel {
    height: 100%;
    padding: 0 0.4rem;
  }
  .headerContentLeft {
    img {
      width: 0.29rem;
      height: 0.28rem;
    }
  }
  .headeContentRight {
    img {
      width: 1.9rem;
      height: 0.4rem;
    }
  }
  .navItemPanel {
    padding: 1.81rem 0 0 0.55rem;
  }
  .navItem {
    width: 100%;
    padding: 0.4rem 0;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(0, 3, 0, 1);
  }
  // 往届回顾
  .dropItemPanel {
    .left-gray-arrow-panel {
      .left-gray-arrow {
        width: 0.4rem;
        height: 0.3rem;
      }
    }
    .right-gray-double-arrow {
      width: 0.25rem;
      height: 0.22rem;
    }
    .dropItemCont {
      padding: 0 0.42rem 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/m/com/mHeaderNav.vue